import { render } from "./ManageUsersView.vue?vue&type=template&id=b2aaa57a"
import script from "./ManageUsersView.vue?vue&type=script&lang=js"
export * from "./ManageUsersView.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__